<mat-spinner aria-label="Operazione in corso - attendere"></mat-spinner>
